import * as React from "react";
import { Modal } from "@grandvisionhq/common";
import { useIntl } from "@grandvisionhq/state";
import { AlternativeShippingMethodsListContainer } from "./AlternativeShippingMethodsListContainer.js";
const AlternateShippingMethodsModal = ({
  onNextStep,
  shouldShowUpdatedShippingMethodsModal,
  closeUpdatedShippingMethodsModal
}) => {
  const { getLabel } = useIntl();
  const labels = {
    alternativeShippingMethodTitle: getLabel("checkout.shipment.method.alternative.modal.title")
  };
  return /* @__PURE__ */ React.createElement(
    Modal,
    {
      "data-t": "alternative-shipping-methods-modal",
      isOpen: shouldShowUpdatedShippingMethodsModal,
      showIcon: true,
      title: labels.alternativeShippingMethodTitle,
      onModalClose: closeUpdatedShippingMethodsModal
    },
    /* @__PURE__ */ React.createElement(
      AlternativeShippingMethodsListContainer,
      {
        closeAlternateShippingModal: closeUpdatedShippingMethodsModal,
        onNextStep
      }
    )
  );
};
export {
  AlternateShippingMethodsModal
};
//# sourceMappingURL=AlternateShippingMethodsModal.js.map
